export enum SignOffCheckType {
    OEM = 'oem',
    EXPERT = 'expert',
    DESIGNER = 'designer',
}

export enum SignOffCheckStatus {
    INIT = 'init',
    OK = 'ok',
    NOT_RELEVANT = 'notRelevant',
}

export const SIGN_OFF_HISTORY_LIMIT = 200;
